import { SaleType as SaleTypeEnum } from "@saleor/types/globalTypes";
// import Moment from "moment";
export const useCreateSalesValidation = initialForm => {
  const {
    description,
    endDate,
    endTime,
    // hasEndDate,
    name,
    startDate,
    startTime,
    type,
    value
  } = initialForm;

  // const dateToday = new Date().toLocaleString() + "";

  // const newStartDate = startDate
  //   ? startDate
  //   : Moment(dateToday).format("YYYY-MM-D");

  // const newStartTime = startTime
  //   ? startTime
  //   : Moment(dateToday).format("HH:mm");
  const descriptionMessage = () => {
    if (description?.length > 700) {
      return "Maximum of 700 characters.";
    }
    return null;
  };
  const startDateMessage = () => {
    if (startDate === "" || startDate === null) {
      return "This field is required.";
    }
    return null;
  };

  const startTimeMessage = () => {
    if (startTime === "" || startTime === null) {
      return "This field is required.";
    }
    return null;
  };

  const endDateMessage = () => {
    if (endDate === "" || endDate === null) {
      return "This field is required.";
    }
    return null;
  };

  const endTimeMessage = () => {
    if (endTime === "" || endTime === null) {
      return "This field is required.";
    }
    return null;
  };
  const nameMessage = () => {
    if (name === "" || name === null) {
      return "This field is required.";
    }

    return null;
  };
  const valueMessage = () => {
    if (type !== "ABSOLUTE_VALUE") {
      if (value === "" || value === null) {
        return "This field is required.";
      } else if (value === 0 || value === "0") {
        return "This field is should not be zero.";
      } else if (value > 100) {
        return "Percentage value is equals or below 100%";
      }
    }
    return null;
  };

  return {
    description: descriptionMessage(),
    endDate: endDateMessage(),
    endTime: endTimeMessage(),
    name: nameMessage(),
    startDate: startDateMessage(),
    startTime: startTimeMessage(),
    value: valueMessage()
  };
};

export const useUpdateSalesValidation = initialForm => {
  const {
    description,
    endDate,
    endTime,
    // hasEndDate,
    name,
    startDate,
    startTime,
    type,
    value
  } = initialForm;

  // const dateToday = new Date().toLocaleString() + "";

  // const newStartDate = startDate
  //   ? startDate
  //   : Moment(dateToday).format("YYYY-MM-D");

  // const newStartTime = startTime
  //   ? startTime
  //   : Moment(dateToday).format("HH:mm");

  const percentageMessage = () => {
    if (type === SaleTypeEnum.PERCENTAGE) {
      if (value > 100) {
        return "Percentage value is equals or below 100%";
      } else if (value === 0 || value === "0") {
        return "This field is should not be zero.";
      }
    }
    return null;
  };

  const descriptionMessage = () => {
    if (description?.length > 700) {
      return "Maximum of 700 characters.";
    }
    return null;
  };
  const startDateMessage = () => {
    if (startDate === "" || startDate === null) {
      return "This field is required.";
    }
    return null;
  };

  const startTimeMessage = () => {
    if (startTime === "" || startTime === null) {
      return "This field is required.";
    }
    return null;
  };

  const endDateMessage = () => {
    if (endDate === "" || endDate === null) {
      return "This field is required.";
    }
    return null;
  };

  const endTimeMessage = () => {
    if (endTime === "" || endTime === null) {
      return "This field is required.";
    }
    return null;
  };
  const nameMessage = () => {
    if (name === "" || name === null) {
      return "This field is required.";
    }

    return null;
  };

  return {
    description: descriptionMessage(),
    endDate: endDateMessage(),
    endTime: endTimeMessage(),
    name: nameMessage(),
    startDate: startDateMessage(),
    startTime: startTimeMessage(),
    value: percentageMessage()
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
